import Popover from '../Popovers/Popover/Popover';

import Content from './components/Content/Content';
import ExportButton from './components/ExportButton';

const Export = ({ showLabel = false, customLabel = showLabel ? 'Export' : '', useData }) => {
  const { getData, gridApi } = useData();

  if (!getData && !gridApi) {
    return null;
  }

  return (
    <Popover
      position="left"
      panelClassName="w-[500px] p-0"
      {...(customLabel && {
        customButtonTrigger: ({ open }) => <ExportButton open={open} customLabel={customLabel} />
      })}>
      {({ closePopover }) => <Content {...{ closePopover, useData }} />}
    </Popover>
  );
};

export default Export;
